<div class="container">
  <app-template [title]="'OBS'" *ngIf="!patient">
    <div class="no">
      <img
        style="width: 150px; height: 150px; margin-left: 20px"
        src="assets/img/error2.png"
        alt=""
      />
      <a
        routerLink="/scan"
        class="waves-effect pull-right"
        style="margin-left: 20px"
      >
        <button
          type="button"
          class="button"
          mat-raised-button
          color="primary"
          style="width: 120px; margin-bottom: 30px"
        >
          Select Result
        </button>
      </a>
      No result selected please click on button above to select a result
    </div>
  </app-template>
  <app-template [title]="'OBS'" *ngIf="patient">
    <button
      class="button"
      mat-raised-button
      color="primary"
      [matMenuTriggerFor]="menu"
      style="margin-right: 30px; width: 120px"
    >
      View Info</button
    >{{ patient?.patient_name }}
    <mat-menu #menu="matMenu" style="width: 400px">
      <table style="text-align: left; margin: 20px">
        <tr>
          <td style="width: 300px">Name</td>
          <td style="width: 500px">{{ FetchPatient?.first_name }}</td>
        </tr>
        <!-- <tr>
          <td>Bill No.</td>
          <td style="width: 500px">{{ patient?.bill_no }}</td>
        </tr> -->
        <tr>
          <td>Title</td>
          <td style="width: 500px">{{ FetchPatient?.title_id }}</td>
        </tr>
        <tr>
          <td>Gender</td>
          <td style="width: 500px">{{ FetchPatient?.sex }}</td>
        </tr>
        <tr>
          <td>Mobile</td>
          <td style="width: 500px">{{ FetchPatient?.mobile }}</td>
        </tr>
      </table>
    </mat-menu>
    <div class="mat">
      <mat-tab-group>
        <mat-tab label="Ft Single">
          <app-ft-single
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
          ></app-ft-single>
        </mat-tab>
        <mat-tab label="Ft Twins">
          <app-ft-twins
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
          ></app-ft-twins>
        </mat-tab>
        <mat-tab label="Ft Triplets">
          <app-ft-triplet
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
          ></app-ft-triplet>
        </mat-tab>
        <mat-tab label="Second Trimester">
          <app-second-trimester
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [fetal_movement]="fetal_movement"
            [image1]="image1"
            [image2]="image2"
          ></app-second-trimester>
        </mat-tab>
        <mat-tab label="Third Trimester">
          <app-third-trimester
            [Patient_type]="Patient_type"
            [gender]="gender"
            [AmnioticFluid]="AmnioticFluid"
            [CervicalOs]="CervicalOs"
            [Chorionicity]="Chorionicity"
            [Amnionicity]="Amnionicity"
            [Grade]="Grade"
            [PlacentaLocation]="PlacentaLocation"
            [PlacentaLocationAnatomic]="PlacentaLocationAnatomic"
            [Presentation]="Presentation"
            [FetalAnomaly]="FetalAnomaly"
            [NoofFetus]="NoofFetus"
            [TechnicalConditions]="TechnicalConditions"
            [FetalHeartBeat]="FetalHeartBeat"
            [image1]="image1"
            [image2]="image2"
            [fetalLie]="fetalLie"
          ></app-third-trimester>
        </mat-tab>
        <mat-tab label="View Result">
          <div style="height: 2000px; margin-top: 50px">
            <div class="but" style="margin: 50px 0">
              <div
                id="print-section"
                [innerHTML]="htmlStr"
                style="display: none"
              ></div>
              <button
                class="create"
                (click)="printResult()"
                style="width: 80px"
                mat-raised-button
                color="primary"
              >
                Print
              </button>

              <button
                class="create"
                (click)="refreshResult()"
                style="width: 80px"
                style="margin-left: 20px"
                *ngIf="!buildLoad"
                mat-raised-button
                color="primary"
              >
                Fetch
              </button>
              <button
                class="create"
                (click)="refreshResult()"
                style="width: 80px"
                style="margin-left: 20px"
                *ngIf="buildLoad"
                mat-raised-button
                color="primary"
              >
                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              </button>

              <!-- <button
                (click)="pushOnline()"
                class="create"
                style="width: 80px"
                style="margin-left: 20px"
                mat-raised-button
                color="primary"
                *ngIf="!isPushing"
              >
                Push Online
              </button> -->
              <!-- <span style="font-size: 13px; font-weight: 400">
                <mat-checkbox
                  style="margin: 20px"
                  color="danger"
                  [(ngModel)]="NotifyDefaultRefDoctor"
                  >Notify Dr.</mat-checkbox
                >
              </span> -->
              <button
                class="create"
                (click)="pushOnlineObs()"
                style="width: 80px"
                style="margin-left: 20px"
                mat-raised-button
                color="primary"
                *ngIf="isPushing"
              >
                <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
              </button>
              <button
                (click)="pushOnlineObs()"
                class="create"
                style="width: 80px"
                style="margin-left: 20px"
                mat-raised-button
                color="primary"
                *ngIf="!isPushing"
              >
                Push Obs Online
              </button>
              <div class="doc-div">
                <div class="content-mx-width" style="margin-right: 100px">
                  <!-- <div (click)="refVisibility()">
                    <button
                      style="margin-top: 10px; margin-right: 100px"
                      mat-raised-button
                      color="primary"
                    >
                      Ref Doctor
                    </button>
                  </div> -->
                  <div class="mobile" *ngIf="refVisible">
                    <div class="mobile_nav">
                      <div class="service">
                        <table style="width: 400px">
                          <tr class="back">
                            <th>
                              <input
                                type="text"
                                class="form-control"
                                id="search-text"
                                aria-describedby="search-text"
                                [(ngModel)]="searchDoc"
                                placeholder="Search items"
                                autofocus
                              />
                            </th>
                            <th>Email</th>
                          </tr>
                          <tr
                            *ngFor="let item of filteredDocs"
                            (click)="addRefDoc(item)"
                            style="cursor: pointer"
                            [ngClass]="{ active: item.selected }"
                          >
                            <td
                              [ngClass]="{
                                inActive: item.status === 'InActive'
                              }"
                            >
                              {{ item.Acount_Name }}
                            </td>
                            <td
                              [ngClass]="{
                                inActive: item.status === 'InActive'
                              }"
                            >
                              {{ item.email }}
                            </td>
                          </tr>
                        </table>
                        <div
                          *ngIf="isLoading"
                          class="spinner"
                          style="margin-top: 40px"
                        >
                          <mat-spinner></mat-spinner>
                        </div>
                        <div class="errorMessage">
                          <div *ngIf="Errors" class="error">
                            <p>{{ Errors }}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="input" style="margin-top: 40px">
                <label
                  class="example-margin"
                  style="margin-left: 0; margin-right: 50px; margin-top: 40px"
                  >Fetus:</label
                >
                <mat-radio-group
                  class="pos"
                  [(ngModel)]="fetuses"
                  (change)="changeFetus($event)"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <mat-checkbox
                    color="primary"
                    class="example-margin"
                    value="A"
                  >
                    FetusA
                  </mat-checkbox>
                  <mat-checkbox
                    color="primary"
                    style="margin-left: 20px"
                    class="example-margin"
                    value="B"
                  >
                    FetusB
                  </mat-checkbox>
                  <mat-checkbox
                    color="primary"
                    style="margin-left: 20px"
                    class="example-margin"
                    value="C"
                  >
                    FetusC
                  </mat-checkbox>
                </mat-radio-group>
              </div>
            </div>

            <div *ngIf="!resultLoad">
              <div id="result">
                <div
                  class="result"
                  id="ft"
                  style="width: 800px; margin: auto; position: relative"
                >
                  <div *ngIf="trimester == 2">
                    <div style="width: 800px">
                      <div
                        style="
                          font-size: 20px;
                          text-align: center;
                          margin-bottom: 5px;
                        "
                      >
                        <B>ANOMALY SCAN ULTRASOUND SCAN REPORT</B>
                      </div>
                      <div
                        style="
                          background-color: black;
                          height: 2px;
                          width: 100%;
                        "
                      ></div>

                      <div style="display: flex; flex-direction: row">
                        <div style="width: 400px">
                          <div style="padding: 20px 0">
                            <table border="0">
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Name
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ PATIENT_NAME }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Age
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ PATIENT_AGE }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Sex
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ Patient_sex }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  ReferredDr
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ PatientRefDr }}
                                </td>
                              </tr>
                            </table>
                          </div>

                          <div>
                            <u
                              ><b
                                >Indication for Scan ans Relevant Clinical
                                Information</b
                              ></u
                            >
                          </div>
                          <div style="padding: 20px 0">
                            <table border="0">
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  LMP
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ lmp }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  G.A[LMP]
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ ga }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Technical Condition
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ tech_condition }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Number of Fetus
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ no_of_fetus }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Chorionicity
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ chorionicity }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Placenta Location
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ p_location }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Cervical OS
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ cervical_os }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Fetal Movement
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ fetal_mment }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  Amniotic Fluid
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 20px;
                                  "
                                >
                                  {{ amniotic_fluid }}
                                </td>
                              </tr>
                            </table>
                          </div>
                          <table border="0">
                            <tr>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  border-top: 1px solid black;
                                  border-bottom: 1px solid black;
                                "
                              >
                                <b>Measurement</b>
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  border-top: 1px solid black;
                                  border-bottom: 1px solid black;
                                "
                              >
                                <b>mm</b>
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  border-top: 1px solid black;
                                  border-bottom: 1px solid black;
                                "
                              >
                                <b>Gestational Age</b>
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 0; padding: 0; margin: 0">
                                Biparietal Diameter
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ bd_mm }}
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ bd_ga }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 0; padding: 0; margin: 0">
                                Femur Diaphysis Length
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ fdl_mm }}
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ fdl_ga }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 0; padding: 0; margin: 0">
                                Abdominal Circumference
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ ac_mm }}
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ ac_ga }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 0; padding: 0; margin: 0">
                                Head Circumference
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ hc_mm }}
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ hc_ga }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 0; padding: 0; margin: 0">
                                Gestational Age[comp]
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              ></td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ g_age }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 0; padding: 0; margin: 0">
                                Estimated Fetal weight
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              ></td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ efw }}
                              </td>
                            </tr>
                            <tr>
                              <td style="border: 0; padding: 0; margin: 0">
                                Expected Delivery Date
                              </td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              ></td>
                              <td
                                style="
                                  border: 0;
                                  padding: 0;
                                  margin: 0;
                                  padding-left: 20px;
                                "
                              >
                                {{ exdd }}
                              </td>
                            </tr>
                          </table>
                          <hr style="margin-top: 20px" />
                          <div><b>Findings[please detail]</b></div>
                          <hr />
                          <div>{{ finding }}</div>

                          <div style="margin-top: 20px"><b>Conclusion</b></div>
                          <hr />
                          <div
                            style="margin-top: 5px"
                            *ngIf="conclusion1 === 'true'"
                          >
                            Normal and Completed Examination
                          </div>
                          <div
                            style="margin-top: 5px"
                            *ngIf="conclusion2 === 'true'"
                          >
                            Normal but Incomplete Examination
                          </div>
                          <div
                            style="margin-top: 5px"
                            *ngIf="conclusion3 === 'true'"
                          >
                            Abnormal Examination
                          </div>
                          <hr style="margin-top: 10px" />
                        </div>
                        <div style="width: 350px; margin-left: 50px">
                          <table border="2">
                            <tbody>
                              <tr>
                                <td style="border-bottom: 1px solid black">
                                  N=Normal <br />Ab=Abnormal<br />NV=Not
                                  Visualized
                                </td>
                                <td
                                  style="
                                    border-bottom: 1px solid black;
                                    padding-left: 10px;
                                  "
                                >
                                  N
                                </td>
                                <td
                                  style="
                                    border-bottom: 1px solid black;
                                    padding-left: 10px;
                                  "
                                >
                                  AB
                                </td>
                                <td
                                  style="
                                    border-bottom: 1px solid black;
                                    padding-left: 10px;
                                  "
                                >
                                  NV
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-top: 1px solid black;
                                    border-bottom: 1px solid black;
                                  "
                                >
                                  <b>Head</b>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-top: 1px solid black;
                                    border-bottom: 1px solid black;
                                  "
                                ></td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-top: 1px solid black;
                                    border-bottom: 1px solid black;
                                  "
                                ></td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-top: 1px solid black;
                                    border-bottom: 1px solid black;
                                  "
                                ></td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Shape</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span>{{
                                    head_shape_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_shape_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_shape_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB"
                                    >Cavum Ceptum pellucidi</span
                                  >
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    head_cavum_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_cavum_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_cavum_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Midline Fallax</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    head_midline_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_midline_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_midline_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Thallamine</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    head_thalami_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_thalami_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_thalami_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr style="border: 0; padding: 0; margin: 0">
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Lateral Ventride</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    head_lateral_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_lateral_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_lateral_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Cerebullum</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    head_cere_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_cere_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    head_cere_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  <span lang="EN-GB">Face</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Upper Lips</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    face_upp_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    face_upp_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    face_upp_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Orbits</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    face_orbit_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    face_orbit_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    face_orbit_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Nose</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    face_nose_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    face_nose_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    face_nose_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Neck</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    neck1 === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{ neck2 === "P" ? "&#10004;" : "&#10008;" }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{ neck3 === "P" ? "&#10004;" : "&#10008;" }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  <span lang="EN-GB">Thorax</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Shape</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    tho_shape_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    tho_shape_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    tho_shape_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">No Masses</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    tho_mass_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    tho_mass_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    tho_mass_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  <span lang="EN-GB">Heart</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Heart Activity</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    heart_activity_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_activity_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_activity_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Size</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    heart_size_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_size_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_size_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Cardiac axis</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB"
                                    >{{
                                      heart_cadic_n === "P"
                                        ? "&#10004;"
                                        : "&#10008;"
                                    }};</span
                                  >
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_cadic_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_cadic_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Four-chamber view</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    heart_chamber_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_chamber_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    heart_chamber_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  <span lang="EN-GB">Abdomen</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Diaphgram</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    abdo_dia_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_dia_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_dia_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Stomach</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    abdo_sto_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_sto_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_sto_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Bowel</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    abdo_bowel_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_bowel_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_bowel_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Kidneys</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    abdo_kidney_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_kidney_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_kidney_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Urinary Bladder</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    abdo_unary_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_unary_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_unary_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB"
                                    >Abdomen cordinsertion</span
                                  >
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    abdo_insert_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_insert_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_insert_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Cord vessels</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    abdo_vessel_n === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_vessel_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    abdo_vessel_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Spine</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    spine1 === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{ spine2 === "P" ? "&#10004;" : "&#10008;" }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{ spine3 === "P" ? "&#10004;" : "&#10008;" }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  <span lang="EN-GB">Limbs</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  &nbsp;
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Right Arm</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    limbs_ra_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_ra_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_ra_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Right Leg</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    limbs_rl_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_rl_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_rl_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Left Arm</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    limbs_la_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_la_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_la_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td style="border: 0; padding: 0; margin: 0">
                                  <span lang="EN-GB">Left Leg</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  <span lang="EN-GB">{{
                                    limbs_ll_n === "P" ? "&#10004;" : "&#10008;"
                                  }}</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_ll_ab === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                  "
                                >
                                  {{
                                    limbs_ll_nv === "P"
                                      ? "&#10004;"
                                      : "&#10008;"
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                >
                                  <span lang="EN-GB">Gender[Optional]</span>
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                    color: red;
                                  "
                                >
                                  {{ sex }}
                                </td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                ></td>
                                <td
                                  style="
                                    border: 0;
                                    padding: 0;
                                    margin: 0;
                                    padding-left: 10px;
                                    border-bottom: 1px solid black;
                                    border-top: 1px solid black;
                                  "
                                ></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        style="
                          height: 2px;
                          width: 100%;
                          background-color: black;
                          margin-top: 20px;
                        "
                      ></div>
                      <div
                        class="sign"
                        style="
                          display: flex;
                          flex-direction: row;
                          justify-content: space-between;
                          z-index: 2;
                        "
                      >
                        <!-- <img
                                      style="width: 170px; height: 170px"
                                      [src]="templates.data.barcode"
                                      alt=""
                                    /> -->
                        <div
                          style="
                            z-index: 2;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                          "
                        >
                          <img
                            style="
                              width: 250px;
                              height: 70px;
                              margin-left: -20px;
                            "
                            [src]="drSign?.signature"
                            alt=""
                          />
                          <div>...........................</div>
                          <div>{{ drSign?.First_Name }}</div>
                          <div>{{ drSign?.designation }}</div>
                          <div>{{ drSign?.qualification }}</div>
                        </div>
                        <div
                          style="
                            z-index: 2;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                          "
                        >
                          <img
                            style="
                              width: 250px;
                              height: 70px;
                              margin-left: -20px;
                            "
                            [src]="radiologist.signature"
                            alt=""
                          />
                          <div>...........................</div>
                          <div>{{ radiologist?.First_Name }}</div>
                          <div>{{ radiologist?.designation }}</div>
                          <div>{{ radiologist?.qualification }}</div>
                        </div>
                      </div>
                      <div style="margin-top: 30px; text-align: left">
                        <b>{{ date | date : "medium" }}</b>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="trimester == 3">
                    <div style="width: 800px">
                      <div
                        style="
                          font-size: 20px;
                          text-align: center;
                          margin-bottom: 15px;
                        "
                      >
                        <B>LATE PREGNANCY SCAN REPORT</B>
                      </div>
                      <div
                        style="
                          background-color: black;
                          height: 2px;
                          width: 100%;
                        "
                      ></div>

                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          justify-content: space-between;
                          margin-top: 10px;
                          font-size: 14px;
                        "
                      >
                        <div style="font-size: 14px">
                          NAME: <b> {{ PATIENT_NAME }} </b>
                        </div>
                        <div style="margin-right: 40px">
                          Referred DR: {{ PatientRefDr }}
                        </div>
                        <div style="margin-right: 40px">
                          AGE: {{ PATIENT_AGE }}
                        </div>
                      </div>

                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          justify-content: space-between;
                          margin-top: 10px;
                          font-size: 14px;
                        "
                      >
                        <div>LMP: {{ lmp }}</div>
                        <div>G.A[LMP]: {{ ga }}</div>
                        <div style="margin-right: 40px">
                          EDD[LMP]: {{ edd }}
                        </div>
                      </div>
                      <div
                        style="
                          background-color: black;
                          height: 2px;
                          width: 100%;
                          margin-top: 15px;
                          margin-bottom: 15px;
                        "
                      ></div>

                      <div
                        style="
                          display: flex;
                          flex-direction: row;
                          justify-content: flex-start;
                        "
                        id="dynamicContent"
                      >
                        <table border="0" style="width: 800px">
                          <tr>
                            <td style="border: 0; padding: 0; width: 600px">
                              <table style="font-size: 16px">
                                <tr style="border: 0; padding: 0; margin: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Number Of Fetus(es) :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ no_of_fetus }}
                                  </td>
                                </tr>
                                <tr style="border: 0; padding: 0; margin: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Fetal Heart Beat:</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ fetal_heart_beat }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Presentation :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ presentation }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Fetal Lie :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ fetus_lie }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>B.P.D (mm) :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ bpd }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>F.L (mm) :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ fl }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>A.C (mm) :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ ac }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>H.C (mm)</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ hc }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Estimated Fetal Weight :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ fet_weg }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Gender :</b>
                                  </td>
                                  <td style="border: 0; padding: 0; color: red">
                                    {{ sex }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>US Average G.A [wks] :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ us_average }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>US EDD :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ uss_edd }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Placenta Location :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ p_location }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Placenta Location [Anatomic] :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ P_location_ana }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Amniotic Fluid :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ amniotic_fluids }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Fetal Anomally :</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ fet }}
                                  </td>
                                </tr>
                                <tr style="border: 0">
                                  <td style="border: 0; padding: 0">
                                    <b>Cervical OS:</b>
                                  </td>
                                  <td style="border: 0; padding: 0">
                                    {{ cervical_os }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td style="border: 0; padding: 0">
                              <div #name></div>
                            </td>
                          </tr>
                        </table>
                      </div>
                      <div style="font-size: 20px; margin-top: 10px">
                        <b>Comments :</b>
                      </div>
                      <div
                        style="
                          background-color: black;
                          height: 2px;
                          width: 100%;
                          margin-bottom: 35px;
                        "
                      ></div>
                      <div style="font-size: 16px">{{ comments }}</div>
                      <br />

                      <div
                        style="
                          background-color: black;
                          height: 2px;
                          width: 100%;
                        "
                      ></div>

                      <div
                        class="sign"
                        style="
                          display: flex;
                          flex-direction: row;
                          justify-content: space-between;
                          z-index: 2;
                        "
                      >
                        <!-- <img
                                      style="width: 170px; height: 170px"
                                      [src]="templates.data.barcode"
                                      alt=""
                                    /> -->
                        <div
                          style="
                            z-index: 2;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                          "
                        >
                          <img
                            style="
                              width: 250px;
                              height: 70px;
                              margin-left: -20px;
                            "
                            [src]="drSign?.signature"
                            alt=""
                          />
                          <div>...........................</div>
                          <div>{{ drSign?.First_Name }}</div>
                          <div>{{ drSign?.designation }}</div>
                          <div>{{ drSign?.qualification }}</div>
                        </div>
                        <div
                          style="
                            z-index: 2;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                          "
                        >
                          <img
                            style="
                              width: 250px;
                              height: 70px;
                              margin-left: -20px;
                            "
                            [src]="radiologist.signature"
                            alt=""
                          />
                          <div>...........................</div>
                          <div>{{ radiologist?.First_Name }}</div>
                          <div>{{ radiologist?.designation }}</div>
                          <div>{{ radiologist?.qualification }}</div>
                        </div>
                      </div>
                      <div style="margin-top: 30px; text-align: left">
                        <b>{{ date | date : "medium" }}</b>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="trimester == '1'">
                    <ng-container *ngIf="no_of_fetuss == '1'">
                      <div style="width: 800px">
                        <div
                          style="
                            font-size: 20px;
                            text-align: center;
                            margin-bottom: 15px;
                          "
                        >
                          <B>EARLY PREGNANCY SCAN REPORT</B>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                          "
                        ></div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 10px;
                            font-size: 14px;
                          "
                        >
                          <div style="font-size: 14px">
                            NAME: <b>{{ PATIENT_TITLE }} {{ PATIENT_NAME }} </b>
                          </div>
                          <div style="margin-right: 40px">
                            Referred DR: {{ PatientRefDr }}
                          </div>
                          <div style="margin-right: 40px">
                            AGE: {{ PATIENT_AGE }}
                          </div>
                        </div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 10px;
                            font-size: 14px;
                          "
                        >
                          <div>LMP: {{ lmp }}</div>
                          <div>G.A[LMP]: {{ ga }}</div>
                          <div style="margin-right: 40px">
                            EDD[LMP]: {{ edd }}
                          </div>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-top: 15px;
                            margin-bottom: 15px;
                          "
                        ></div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                          "
                          id="dynamicContent"
                        >
                          <table style="border: 0; padding: 0">
                            <tr style="border: 0; padding: 0">
                              <td style="border: 0; padding: 0; width: 600px">
                                <table style="font-size: 16px">
                                  <tr style="border: 0; padding: 0; margin: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Number Of Fetus(es) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ no_of_fetus }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0; padding: 0; margin: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Fetal Heart :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ fetal_heart_beat }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>C.R.L(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ crl }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>N.T Thickness(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ nt_thikness }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Amniotic Fluid :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ amniotic_fluids }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Placenta Location :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ p_location }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>US Average G.A[wks] :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ us_average }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>US EDD :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ uss_edd }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>"Mean GSD" :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ mean_gsd }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Gender :</b>
                                    </td>
                                    <td
                                      style="border: 0; padding: 0; color: red"
                                    >
                                      {{ genders }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Right Adnexium :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ right_adnexium }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Left Adnexium :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ left_adnexium }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Cervical Os :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ cervical_os }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>B.P.D(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ bpd }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>F.L(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ fl }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>A.C(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ ac }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>H.C(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ hc }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>EFW(kg) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ efw }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Technical Conditions :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ tech_condition }}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td style="border: 0; padding: 0">
                                <div #name [innerHTML]="ftimage"></div>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Other Findings :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div style="font-size: 16px">{{ other_finding }}</div>
                        <br />

                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Comments :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div style="font-size: 16px">{{ comments }}</div>
                        <br />

                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Suggestion :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div
                          style="font-size: 16px; margin-top: 5px"
                          *ngIf="suggestion1 === 'true'"
                        >
                          A Repeat scan in 2 weeks is Advised
                        </div>
                        <div
                          style="font-size: 16px; margin-top: 5px"
                          *ngIf="suggestion2 === 'true'"
                        >
                          A mid-trimester Anomally Scan at 16-24 weeks G.A is
                          advised
                        </div>
                        <div
                          style="
                            font-size: 16px;
                            margin-top: 5px;
                            margin-bottom: 15px;
                          "
                          *ngIf="suggestion3 === 'true'"
                        >
                          Please come with a copy of this report at your next
                          appointment
                        </div>

                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                          "
                        ></div>
                        <div
                          class="sign"
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            z-index: 2;
                          "
                        >
                          <!-- <img
                                            style="width: 170px; height: 170px"
                                            [src]="templates.data.barcode"
                                            alt=""
                                          /> -->
                          <div
                            style="
                              z-index: 2;
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                            "
                          >
                            <img
                              style="
                                width: 250px;
                                height: 70px;
                                margin-left: -20px;
                              "
                              [src]="drSign?.signature"
                              alt=""
                            />
                            <div>...........................</div>
                            <div>{{ drSign?.First_Name }}</div>
                            <div>{{ drSign?.designation }}</div>
                            <div>{{ drSign?.qualification }}</div>
                          </div>
                          <div
                            style="
                              z-index: 2;
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                            "
                          >
                            <img
                              style="
                                width: 250px;
                                height: 70px;
                                margin-left: -20px;
                              "
                              [src]="radiologist.signature"
                              alt=""
                            />
                            <div>...........................</div>
                            <div>{{ radiologist?.First_Name }}</div>
                            <div>{{ radiologist?.designation }}</div>
                            <div>{{ radiologist?.qualification }}</div>
                          </div>
                        </div>
                        <div style="margin-top: 30px; text-align: left">
                          <b>{{ date | date : "medium" }}</b>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="no_of_fetuss == '2'">
                      <div style="width: 800px">
                        <div
                          style="
                            font-size: 20px;
                            text-align: center;
                            margin-bottom: 15px;
                          "
                        >
                          <B>EARLY PREGNANCY SCAN REPORT</B>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                          "
                        ></div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 10px;
                            font-size: 14px;
                          "
                        >
                          <div style="font-size: 14px">
                            NAME: <b>{{ PATIENT_TITLE }} {{ PATIENT_NAME }} </b>
                          </div>
                          <div style="margin-right: 40px">
                            Referred DR: {{ PatientRefDr }}
                          </div>
                          <div style="margin-right: 40px">
                            AGE: {{ PATIENT_AGE }}
                          </div>
                        </div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 10px;
                            font-size: 14px;
                          "
                        >
                          <div>LMP: {{ lmp }}</div>
                          <div>G.A[LMP]: {{ ga }}</div>
                          <div style="margin-right: 40px">
                            EDD[LMP]: {{ edd }}
                          </div>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-top: 15px;
                            margin-bottom: 15px;
                          "
                        ></div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                          "
                          id="dynamicContent"
                        >
                          <table style="border: 0; padding: 0; margin: 0">
                            <tr style="border: 0; padding: 0; margin: 0">
                              <td style="border: 0; padding: 0; margin: 0">
                                <table style="font-size: 16px; width: 600px">
                                  <tr style="border: 0; padding: 0; margin: 0">
                                    <td style="border: 0; padding: 0">
                                      <b></b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        margin-left: 60px;
                                      "
                                    >
                                      <b>Fetus 1</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      <b>Fetus 2</b>
                                    </td>
                                  </tr>
                                  <tr style="border: 0; padding: 0; margin: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Number Of Fetus(es) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ no_of_fetus }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ no_of_fetus2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0; padding: 0; margin: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Fetal Heart :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ fetal_heart_beat }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fetal_heart_beat2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>C.R.L(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ crl }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ crl2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>N.T Thickness(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ nt_thikness }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ nt_thikness2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Amniotic Fluid :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ amniotic_fluids }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ amniotic_fluids2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Placenta Location :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ p_location }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ p_location2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>US Average G.A[wks] :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ us_average }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ us_average2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>US EDD :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ uss_edd }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ uss_edd2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>"Mean GSD" :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ mean_gsd }}
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ mean_gsd2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Gender :</b>
                                    </td>
                                    <td
                                      style="border: 0; padding: 0; color: red"
                                    >
                                      {{ genders }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                        color: red;
                                      "
                                    >
                                      {{ genders2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Right Adnexium :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ right_adnexium }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ right_adnexium2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Left Adnexium :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ left_adnexium }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ left_adnexium2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Cervical Os :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ cervical_os }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ cervical_os2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>B.P.D(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ bpd }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ bpd2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>F.L(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ fl }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fl2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>A.C(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ ac }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ ac2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>H.C(mm) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ hc }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ hc2 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>EFW(kg) :</b>
                                    </td>
                                    <td style="border: 0; padding: 0">
                                      {{ efw }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ efw2 }}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td style="border: 0; padding: 0">
                                <div #name></div>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Other Findings :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div style="font-size: 16px">{{ other_finding }}</div>
                        <br />

                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Comments :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div style="font-size: 16px">{{ comments }}</div>
                        <br />

                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Suggestion :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div
                          style="font-size: 16px; margin-top: 5px"
                          *ngIf="suggestion1 === 'true'"
                        >
                          A Repeat scan in 2 weeks is Advised
                        </div>
                        <div
                          style="font-size: 16px; margin-top: 5px"
                          *ngIf="suggestion2 === 'true'"
                        >
                          A mid-trimester Anomally Scan at 16-24 weeks G.A is
                          advised
                        </div>
                        <div
                          style="
                            font-size: 16px;
                            margin-top: 5px;
                            margin-bottom: 15px;
                          "
                          *ngIf="suggestion3 === 'true'"
                        >
                          Please come with a copy of this report at your next
                          appointment
                        </div>

                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                          "
                        ></div>

                        <div
                          class="sign"
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            z-index: 2;
                          "
                        >
                          <!-- <img
                                          style="width: 170px; height: 170px"
                                          [src]="templates.data.barcode"
                                          alt=""
                                        /> -->
                          <div
                            style="
                              z-index: 2;
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                            "
                          >
                            <img
                              style="
                                width: 250px;
                                height: 70px;
                                margin-left: -20px;
                              "
                              [src]="drSign?.signature"
                              alt=""
                            />
                            <div>...........................</div>
                            <div>{{ drSign?.First_Name }}</div>
                            <div>{{ drSign?.designation }}</div>
                            <div>{{ drSign?.qualification }}</div>
                          </div>
                          <div
                            style="
                              z-index: 2;
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                            "
                          >
                            <img
                              style="
                                width: 250px;
                                height: 70px;
                                margin-left: -20px;
                              "
                              [src]="radiologist.signature"
                              alt=""
                            />
                            <div>...........................</div>
                            <div>{{ radiologist?.First_Name }}</div>
                            <div>{{ radiologist?.designation }}</div>
                            <div>{{ radiologist?.qualification }}</div>
                          </div>
                        </div>
                        <div style="margin-top: 30px; text-align: left">
                          <b>{{ date | date : "medium" }}</b>
                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="no_of_fetuss == '3'">
                      <div style="width: 800px">
                        <div
                          style="
                            font-size: 20px;
                            text-align: center;
                            margin-bottom: 15px;
                          "
                        >
                          <B>EARLY PREGNANCY SCAN REPORT</B>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                          "
                        ></div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 10px;
                            font-size: 14px;
                          "
                        >
                          <div style="font-size: 14px">
                            NAME: <b>{{ PATIENT_TITLE }} {{ PATIENT_NAME }} </b>
                          </div>
                          <div style="margin-right: 40px">
                            Referred DR: {{ PatientRefDr }}
                          </div>
                          <div style="margin-right: 40px">
                            AGE: {{ PATIENT_AGE }}
                          </div>
                        </div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            margin-top: 10px;
                            font-size: 14px;
                          "
                        >
                          <div>LMP: {{ lmp }}</div>
                          <div>G.A[LMP]: {{ ga }}</div>
                          <div style="margin-right: 40px">
                            EDD[LMP]: {{ edd }}
                          </div>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-top: 15px;
                            margin-bottom: 15px;
                          "
                        ></div>

                        <div
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                          "
                          id="dynamicContent"
                        >
                          <table style="border: 0; padding: 0; margin: 0">
                            <tr style="border: 0; padding: 0; margin: 0">
                              <td style="border: 0; padding: 0; margin: 0">
                                <table style="font-size: 16px; width: 750px">
                                  <tr>
                                    <td style="border: 0; padding: 0">
                                      <b></b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      <b>Fetus 1</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      <b>Fetus 2</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      <b>Fetus 3</b>
                                    </td>
                                  </tr>
                                  <tr style="border: 0; padding: 0; margin: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Number Of Fetus(es) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ no_of_fetus }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ no_of_fetus2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ no_of_fetus3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0; padding: 0; margin: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Fetal Heart :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fetal_heart_beat }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fetal_heart_beat2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fetal_heart_beat3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>C.R.L(mm) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ crl }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ crl2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ crl3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>N.T Thickness(mm) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ nt_thikness }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ nt_thikness2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ nt_thikness3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Amniotic Fluid :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ amniotic_fluids }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ amniotic_fluids2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ amniotic_fluids3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Placenta Location :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ p_location }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ p_location2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ p_location3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>US Average G.A[wks] :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ us_average }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ us_average2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ us_average3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>US EDD :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ uss_edd }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ uss_edd2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ uss_edd3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>"Mean GSD" :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ mean_gsd }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ mean_gsd2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ mean_gsd3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Gender :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                        color: red;
                                      "
                                    >
                                      {{ genders }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                        color: red;
                                      "
                                    >
                                      {{ genders2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                        color: red;
                                      "
                                    >
                                      {{ genders3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Right Adnexium :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ right_adnexium }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ right_adnexium2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ right_adnexium3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Left Adnexium :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ left_adnexium }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ left_adnexium2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ left_adnexium3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>Cervical Os :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ cervical_os }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ cervical_os2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ cervical_os3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>B.P.D(mm) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ bpd }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ bpd2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ bpd3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>F.L(mm) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fl }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fl2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ fl3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>A.C(mm) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ ac }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ ac2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ ac3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>H.C(mm) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ hc }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ hc2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ hc3 }}
                                    </td>
                                  </tr>
                                  <tr style="border: 0">
                                    <td style="border: 0; padding: 0">
                                      <b>EFW(kg) :</b>
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ efw }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ efw2 }}
                                    </td>
                                    <td
                                      style="
                                        border: 0;
                                        padding: 0;
                                        padding-left: 60px;
                                      "
                                    >
                                      {{ efw3 }}
                                    </td>
                                  </tr>
                                </table>
                              </td>
                              <td style="border: 0; padding: 0">
                                <div #name></div>
                              </td>
                            </tr>
                          </table>
                        </div>
                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Other Findings :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div style="font-size: 16px">{{ other_finding }}</div>
                        <br />

                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Comments :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div style="font-size: 16px">{{ comments }}</div>
                        <br />

                        <div style="font-size: 20px; margin-top: 10px">
                          <b>Suggestion :</b>
                        </div>
                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                            margin-bottom: 35px;
                          "
                        ></div>
                        <div
                          style="font-size: 16px; margin-top: 5px"
                          *ngIf="suggestion1 === 'true'"
                        >
                          A Repeat scan in 2 weeks ia Advised
                        </div>
                        <div
                          style="font-size: 16px; margin-top: 5px"
                          *ngIf="suggestion2 === 'true'"
                        >
                          A mid-trimester Anomally Scan at 16-24 weeks G.A is
                          advised
                        </div>
                        <div
                          style="
                            font-size: 16px;
                            margin-top: 5px;
                            margin-bottom: 15px;
                          "
                          *ngIf="suggestion3 === 'true'"
                        >
                          Please come with a copy of this report at your next
                          appointment
                        </div>

                        <div
                          style="
                            background-color: black;
                            height: 2px;
                            width: 100%;
                          "
                        ></div>

                        <div
                          class="sign"
                          style="
                            display: flex;
                            flex-direction: row;
                            justify-content: space-between;
                            z-index: 2;
                          "
                        >
                          <!-- <img
                                          style="width: 170px; height: 170px"
                                          [src]="templates.data.barcode"
                                          alt=""
                                        /> -->
                          <div
                            style="
                              z-index: 2;
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                            "
                          >
                            <img
                              style="
                                width: 250px;
                                height: 70px;
                                margin-left: -20px;
                              "
                              [src]="drSign?.signature"
                              alt=""
                            />
                            <div>...........................</div>
                            <div>{{ drSign?.First_Name }}</div>
                            <div>{{ drSign?.designation }}</div>
                            <div>{{ drSign?.qualification }}</div>
                          </div>
                          <div
                            style="
                              z-index: 2;
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                            "
                          >
                            <img
                              style="
                                width: 250px;
                                height: 70px;
                                margin-left: -20px;
                              "
                              [src]="radiologist.signature"
                              alt=""
                            />
                            <div>...........................</div>
                            <div>{{ radiologist?.First_Name }}</div>
                            <div>{{ radiologist?.designation }}</div>
                            <div>{{ radiologist?.qualification }}</div>
                          </div>
                        </div>
                        <div style="margin-top: 30px; text-align: left">
                          <b>{{ date | date : "medium" }}</b>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <!-- <div class="detail" style=" margin-top: 0px; z-index: 2;display: flex; flex-direction: row; justify-content: space-evenly; margin-bottom: 20px; margin-left: 30px;">
                                    <div class="main" style=" z-index: 2;margin-left: 30px;">
                                     <div class="head"><b>Patient Name  :</b>   {{templates.data?.patient_name}}</div>
                                     <div class="name"><b>Referred Code :</b>   {{templates.data?.referred_code}}</div>
                                     <div class="name"><b>Bill No. :</b>   {{templates.data?.bill_id}}</div>
                                     <div class="name"><b>Result No. :</b>   {{templates.data?.result_id}}</div>
                                    </div>
                                    <div class="main" style=" z-index: 2; margin-left: 40px;">
                                     <div class="name"><b>Reporting Date:</b>   {{templates.data?.reporting_date}}</div>
                                     <div class="name"><b>Sex:</b>   {{templates.data?.sex}}</div>
                                     <div class="name"><b>Age:</b>   {{templates.data?.age}}</div>
                                     <div class="name"><b>Reg No:</b>   {{templates.data?.reg_code}}</div>
                                    </div>
                                  </div> -->

                  <!-- <div class="return" style="width: 600px; margin-left: 100px; margin-bottom: 5px; z-index: 2;" #name ></div> -->

                  <!-- <div style="margin-left: 100px; font-size: 15px;"> Electronically Signed and Authenticated by <b>{{templates.data?.initator?.name}}</b></div> -->
                </div>

                <div
                  class="result"
                  id="ft"
                  style="width: 800px; margin: auto; position: relative"
                >
                  <div style="width: 800px"></div>
                </div>

                <!-- <div style="height: 500px; width: 100%;"></div> -->
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </app-template>
</div>
